export const DIRECTION = {
    none: null,
    asc: 'asc',
    desc: 'desc',
};
